<template>
  <div>
      <div class="news-list">
        <div class="order-item" v-for="(item,index) in list" @click="prevImg(item)">
            <div class="item-message">
                <div class="mess-name">{{item.name}}</div>
                <div class="mess-schedule">您已成功预定景区门票！</div>
                <div class="mess-time">游玩时间：{{formatDateA(item.scheduled_time,'yymmdd')}}</div>
                <div class="mess-time" >核销时间：{{item.cancel_time || '未核销'}}</div>
            </div>
            <div class="item-img">
                 <!-- <van-image :src="item.qr_code" fit="cover" ></van-image> -->
                 <canvas :id="`qr${index}`" ></canvas>
            </div>
        </div>
        <van-empty v-if="empty" description="暂无预定"></van-empty>
      </div>
      <div class="remarks" v-if="!empty">请及时前往景区凭借二维码扫码入园哦~</div>
      <van-popup v-model="imgPop">
        <div class="showImg" v-if="curInfo">
            <p class="name">{{ curInfo.name }}</p>
            <p class="info">请于 {{formatDateA(curInfo.scheduled_time,"yymmdd") }} 当日核销！</p>
            <!-- <van-image :src="curInfo.qr_code" fit="cover" ></van-image> -->
            <canvas id="preCavans"></canvas>
        </div>
      </van-popup>
  </div>
</template>
<script>
import hz from "@/assets/images/hz.png"
import QrCode from "qrcode"
export default {
  components: {

  },
  name: '',
  props: {
    show:Boolean
  },
  data() {
    return {
        hz,
        list:null,
        empty:false,
        imgPop:false,
        curInfo:null
    }
  },
  watch:{
    show:{
        handler(newv,oldv){
            if(newv){
                this.getList()
            }
        },immediate:true
    }
  },
  mounted(){
  },
  computed:{

  },
  methods:{
    getList(){
        this.$api.orderApi.getList({
            type:1
        }).then(res=>{
            if(res && res.data && res.data.length>0){
                let list = res.data
                this.list = list
                this.empty =false
                setTimeout(() => {
                    this.getQr()
                    
                }, 100);
            }else{
                this.list = null
                this.empty = true
            }
        })
    },
    getQr(){
        this.list.map((t,i)=>{
            let str = `id=${t.id}`
            QrCode.toCanvas(
                document.getElementById(`qr${i}`),
                str,
                { width:100, height:100, },
                error => {}
            );
        })
    },

    prevImg(info){
        if(info.cancel_time){
            this.$toast("您已核销过该门票")
            return
        }
        this.curInfo = info
        let str = `id=${info.id}`
        this.imgPop = true
        setTimeout(() => {
            QrCode.toCanvas(
                document.getElementById("preCavans"),
                str,
                { width:270, height:270, },
                error => {}
            ); 
        }, 100);
        
        
        
    }
  },
}
</script>
<style scoped lang="scss">
.news-list{
    padding: 0 20rem;
}
.order-item {
    padding: 15rem 0;
    border-bottom: 1rem solid #eee;
    display: flex;
    box-sizing: border-box;
    &:last-child {
        border-bottom: 0;
    }
        .item-message {
            color: #3D3D3D;
            .mess-name {
                color: #000000;
                font-size: 16rem;
                line-height: 25rem;
                font-weight: 700;
            }
            .mess-schedule {
                font-size: 14rem;
                line-height: 25rem;
            }
            .mess-time {
                font-size: 12rem;
                line-height: 20rem;
            }
    }
    .item-img {
        width: 100rem;
        height: 100rem;
        margin-left: auto;
        canvas{
            width: 100%;
            height: 100%;
            background: #f1f1f1;
        }
    }
}

.showImg{
    background: #fff;
    border-radius: 10rem;
    overflow: hidden;
    padding: 10rem;
    width: 300rem;
    box-sizing: border-box;
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .name{
        font-size: 16rem;
        margin-bottom: 10rem;
    }
    .info{
        font-size: 14rem;
        margin-bottom: 10rem;
    }
    // height: 300rem;
    .van-image{
        width: 280rem;
        height: 280rem;
    }
}


</style>
